import React from 'react';
import Tabs from '@src/new-components/Tabs';
import { COLOR } from '@src/styles/color';
import { StyledTabs } from './index.style';

const TransactionHistoryTabs = ({ activeTab, handleChangeTab, tabs }) => (
  <StyledTabs>
    <Tabs
      tabs={tabs}
      activeTab={activeTab}
      onChange={handleChangeTab}
      styleTab={{
        borderRadius: '0',
        backgroundColor: 'transparent',
        activeBackgroundColor: COLOR.white,
        activeBorderRadius: '8px',
        padding: '8px 16px',
        boxSizing: 'border-box',
        height: '40px',
      }}
      styleTabs={{
        gap: '0px',
        height: '48px',
        borderRadius: '12px',
        boxSizing: 'border-box',
        overflow: 'hidden',
        backgroundColor: COLOR.activeMenu,
        padding: '4px',
        alignSelf: 'flex-start',
        border: `0.5px solid ${COLOR.secondary[16]}`,
      }}
      activeTextVariant="body-14-semibold"
      textVariant="body-14-semibold"
    />
  </StyledTabs>
);

export default TransactionHistoryTabs;
